import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'weekday',
  getItemSize: () => 45,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.recurOnDaysOfWeek,
  getOnChange: (self) => (each) => {
    updateSessionItem(getStorageKey(), {}, (draft) => {
      const index = draft.item.recurOnDaysOfWeek.findIndex((one) => one === each.id)

      if (index > -1) {
        draft.item.recurOnDaysOfWeek.splice(index, 1)
      } else {
        draft.item.recurOnDaysOfWeek.push(each.id)
      }
    })
  },
  allowMultiple: true,
  allowSelectAllWhenMultiple: false,
})()
